import { trim, isType } from "@utils";

const doc = window.document;

function get(key) {
  if (!key || !_has(key)) {
    return null;
  }

  // 使用更简化的正则表达式
  let regexpStr = "(?:^|;\\s*)" +
    encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") +
    "\\s*=\\s*([^;]*)"; // 直接匹配到下一个分号或字符串结尾

  try {
    const match = doc.cookie.match(new RegExp(regexpStr));
    // 如果未匹配到键，直接返回null
    if (!match) {
      return null;
    }
    // 移除废弃的unescape，直接使用decodeURIComponent
    const cookieValue = decodeURIComponent(match[1]);
    return JSON.parse(cookieValue);
  } catch (e) {
    console.error('Cookie解析失败:', e);
    return null;
  }
}

function all() {
  let cookies = doc.cookie.split(/; ?/g),
    data = {};
  for (let i = cookies.length - 1; i >= 0; i--) {
    if (!trim(cookies[i])) {
      continue;
    }
    let kvp = cookies[i].split("=");
    let key = decodeURIComponent(kvp[0]);
    data[key] = decodeURIComponent(kvp[1]);
  }
  return data;
}

function set(key, data, time) {
  if (!key) {
    return;
  }
  
  let expiresDate;
  if (isType(time, "Date") || time instanceof Date) {
    expiresDate = time;
  } else if (time) {
    expiresDate = new Date(time);
    if (isNaN(expiresDate.getTime())) {
      // 如果解析失败，使用默认过期时间
      //expiresDate = new Date('Tue, 19 Jan 2038 03:14:07 GMT');
      expiresDate = new Date('2038-11-10T12:00:00');
    }
  } else {
    // 默认过期时间：2038/1/19
    //expiresDate = new Date('Tue, 19 Jan 2038 03:14:07 GMT');
    expiresDate = new Date('2038-11-10T12:00:00');
  }
  
  // 使用标准的UTC字符串格式，确保iOS兼容性
  const expiresStr = expiresDate.toUTCString();
  
  try {
    const encodedValue = encodeURIComponent(JSON.stringify(data));
    doc.cookie = encodeURIComponent(key) + "=" + encodedValue + "; expires=" + expiresStr + "; path=/; SameSite=Lax";
  } catch (e) {
    console.error('Cookie设置失败:', e);
  }
}

function formatDate(date) {
  var dates = new Date(date);
  var YY = dates.getFullYear() + "-";
  var MM =
    (dates.getMonth() + 1 < 10
      ? "0" + (dates.getMonth() + 1)
      : dates.getMonth() + 1) + "-";
  var DD = dates.getDate() < 10 ? "0" + dates.getDate() : dates.getDate();
  var hh =
    (dates.getHours() < 10 ? "0" + dates.getHours() : dates.getHours()) + ":";
  var mm =
    (dates.getMinutes() < 10 ? "0" + dates.getMinutes() : dates.getMinutes()) +
    ":";
  var ss =
    dates.getSeconds() < 10 ? "0" + dates.getSeconds() : dates.getSeconds();
  return YY + MM + DD + " " + hh + mm + ss;
}

function remove(key) {
  if (!key || !_has(key)) {
    return;
  }
  //使用标准的过期时间格式
  const expiresStr = new Date('Thu, 01 Jan 1970 00:00:00 GMT').toUTCString();
  doc.cookie = encodeURIComponent(key) + "=; expires=" + expiresStr + "; path=/";
}

function clearAll() {
  Object.keys(all()).forEach(function(key) {
    remove(key);
  });
}

function _has(key) {
  return new RegExp(
    "(?:^|;\\s*)" + encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") + "\\s*\\="
  ).test(doc.cookie);
}

export default {
  get,
  all,
  set,
  remove,
  clearAll,
  has: _has
};
